import { v4 as uuidv4 } from "uuid";
import { Auth, CognitoUser } from "@aws-amplify/auth";
import apiClient from "src/utils/apiClient";
import { CognitoUserSession } from "amazon-cognito-identity-js";

const TOKEN = "token";

const getCurrentUser = async (): Promise<CognitoUser | null> => {
  try {
    return await Auth.currentAuthenticatedUser();
  } catch (e) {
    console.error(e);
    return null;
  }
};
const federatedSignIn = () =>
  Auth.federatedSignIn({
    customProvider: "FederateOIDC",
    customState: window.location.href,
  });
const login = async () => {
  const currentUser = {
    alias: "",
    token: "",
    lastName: "",
    firstName: "",
    email: "",
    siteLocation: "",
    ldap: [] as string[],
  };

  const user = await getCurrentUser();

  if (!user) {
    // Do NOT auto-start the login sequence here. Resolve as unauthenticated so
    // the app shows the splash screen; login is initiated explicitly when the
    // user taps LOGIN on the splash screen (userSlice.signIn()).
    localStorage.removeItem(TOKEN);
    console.info("No authenticated session found; showing splash screen");
    throw new Error("No authenticated session");
  }

  if (user) {
    return new Promise<typeof currentUser>((resolve, reject) => {
      user.getSession((err: Error | null, session: CognitoUserSession) => {
        if (err || !session) {
          reject(new Error("Failed to get user session"));
          return;
        }

        try {
          const token = session.getIdToken().getJwtToken();
          currentUser.token = token;
          const decodeToken = session.getIdToken().decodePayload();
          currentUser.alias =
            decodeToken?.identities?.[0]?.userId ??
            decodeToken["email"]!.split("@")[0];

          // Extract LDAP groups from JWT token payload
          const ldapGroupsString = decodeToken["custom:LDAP_GROUP"] || "";
          currentUser.ldap = ldapGroupsString
            ? ldapGroupsString.split(",").map((group: string) => group.trim())
            : [];
          currentUser.firstName = decodeToken["given_name"] || "";
          currentUser.lastName = decodeToken["family_name"] || "";
          currentUser.email = decodeToken["email"] || "";
          currentUser.siteLocation = decodeToken["custom:location"] || "";
          localStorage.setItem("token", token);
          apiClient.interceptors.request.use(async (config) => {
            config.headers = {
              authorization: "Bearer " + localStorage.getItem(TOKEN),
              "Content-Type": "application/json",
              clientRequestId: uuidv4(),
            };
            return config;
          });
          resolve(currentUser);
        } catch (decodeError) {
          reject(new Error("Failed to decode JWT token"));
        }
      });
    });
  }

  return currentUser;
};
const logout = () => {
  localStorage.removeItem(TOKEN);
};

export default {
  login,
  federatedSignIn,
  logout,
};
